import { useState } from "react";
import { guideItems } from "@/mocks/site";

export default function WatchGuide() {
  const [openId, setOpenId] = useState<string>(guideItems[0].id);

  return (
    <section id="guide" className="w-full border-b border-background-200 bg-secondary-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.4fr] lg:gap-12">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-accent-700">Start Here</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">观看指南</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              第一次接触这类短剧，从哪部开始、单集多长、怎么用分类找内容——下面四条按顺序看一遍，基本就能上手。
            </p>
            <div className="mt-6 rounded-lg border border-secondary-200 bg-background-50 p-5">
              <p className="flex items-center gap-2 text-sm font-medium text-foreground-800">
                <span className="flex h-5 w-5 items-center justify-center text-accent-600">
                  <i className="ri-lightbulb-flash-line text-base" aria-hidden="true" />
                </span>
                小提示
              </p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                拿不准看哪部时，先在上方按「题材」筛一次，再从热度最高的三个里挑一个。单集短，试错成本几乎为零。
              </p>
            </div>
          </div>

          <div className="space-y-3">
            {guideItems.map((item, index) => {
              const isOpen = openId === item.id;
              return (
                <div
                  key={item.id}
                  className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                    isOpen ? "border-primary-300" : "border-secondary-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenId(isOpen ? "" : item.id)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="flex items-center gap-3">
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"
                        }`}
                      >
                        {index + 1}
                      </span>
                      <span className="font-medium text-foreground-900">{item.title}</span>
                    </span>
                    <span className="flex h-5 w-5 shrink-0 items-center justify-center text-foreground-500">
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true" />
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 pl-[3.75rem] text-sm leading-relaxed text-foreground-600">{item.body}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}